import React from 'react'

import { Store } from 'panel/store/redux/types'
import { NavLink } from 'react-router-dom'
import { getBucketInfo } from 'panel/storage/service/store.service'

const AlertBucketFull: React.FC<{ store: Store }> = ({ store }) => {
  const { data } = getBucketInfo()

  const percentage = data?.percentage || 0
  if (percentage >= 80 && percentage < 100) {
    return (
      <div className="row alert-box warning">
        <i className="fa fa-exclamation-triangle" />
        Seu armazenamento está quase cheio ({percentage.toFixed(2)}%)
        <NavLink to="/panel/storage?page=1&limit=10&order.by=DATE&order.direction=ASC" className="button">
          <i className="fa fa-trash-alt" style={{ color: 'white' }} /> Revisar armazenamento
        </NavLink>
        <NavLink to="/panel/invoice" className="button">
          <i className="fa fa-star" /> Fazer upgrade do plano
        </NavLink>
      </div>
    )
  }

  if (percentage >= 100) {
    return (
      <div className="row alert-box danger">
        <i className="fa fa-exclamation-triangle" />
        Seu armazenamento está cheio (novos arquivos substituirão os mais antigos)
        <NavLink to="/panel/storage?page=1&limit=10&order.by=DATE&order.direction=ASC" className="button">
          <i className="fa fa-trash-alt" style={{ color: 'white' }} /> Revisar armazenamento
        </NavLink>
        <NavLink to="/panel/invoice" className="button">
          <i className="fa fa-star" /> Fazer upgrade do plano
        </NavLink>
      </div>
    )
  }

  return null
}

export default AlertBucketFull
